import { api } from './api';

export interface Tag {
  id: string;
  slug: string;
  name: string;
  color?: string | null;
  order: number;
  createdAt?: string;
  updatedAt?: string;
  _count?: {
    articles: number;
  };
}

export interface CreateTagInput {
  name: string;
  slug: string;
  color?: string;
  order?: number;
}

export interface UpdateTagInput {
  name?: string;
  slug?: string;
  color?: string;
  order?: number;
}

export const tagsService = {
  /**
   * Get all tags
   */
  async getAll(): Promise<Tag[]> {
    const response = await api.get('/api/admin/tags');
    return response.data.data;
  },

  /**
   * Get a tag by ID
   */
  async getById(id: string): Promise<Tag> {
    const response = await api.get(`/api/admin/tags/${id}`);
    return response.data.data;
  },

  /**
   * Create a new tag
   */
  async create(data: CreateTagInput): Promise<Tag> {
    const response = await api.post('/api/admin/tags', data);
    return response.data.data;
  },

  /**
   * Update a tag
   */
  async update(id: string, data: UpdateTagInput): Promise<Tag> {
    const response = await api.put(`/api/admin/tags/${id}`, data);
    return response.data.data;
  },

  /**
   * Delete a tag
   */
  async delete(id: string): Promise<void> {
    await api.delete(`/api/admin/tags/${id}`);
  },

  /**
   * Reorder tags
   */
  async reorder(tags: { id: string; order: number }[]): Promise<void> {
    await api.post('/api/admin/tags/reorder', { tags });
  },
};
